export default (state, entityKey, currentId) => {
  return state.savedEntities[entityKey]?.items.find(
    (item) => item.id === currentId
  );
};
